import React from 'react';

import styles from './form-item.module.css';

export const ErrorMessage: React.FC<React.HtmlHTMLAttributes<HTMLSpanElement>> = ({children}) => {

  return (
    <span className={styles.error}>
      {children}
    </span>
  )
};
